<template>
    <div
        :class="{
            [$style['content']]: true,
            [$style['content_center']]: position === 'center',
            [$style['content_right']]: position === 'right'
        }"
    >
        <SwPanel :class="$style['content__box']">
            <h2
                :class="[$style['content__title'], 'sw-title']"
                v-html="title"
            />

            <div
                :class="[$style['content__text'], 'sw-text']"
                v-html="text"
            />
        </SwPanel>
    </div>
</template>

<script>
export default {
  name: 'TextOnImage',

  props: {
    title: {
      type: String,
      default: 'Заголовок текстового блока'
    },

    text: {
      type: String,
      default: 'Небольшое описание вашего товара. Используйте этот текст, чтобы дать вашим клиентам представление о вашем товаре'
    },

    position: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style lang="less" module>
@import (reference) "@@/assets/Web.less";

.content {
  display: flex;
  align-items: center;
  min-height: 500px;
  margin: auto 0;

  &_center { justify-content: center; text-align: center; }
  &_right { justify-content: flex-end; }

  &__box {
    display: flex;
    flex-wrap: wrap;
    max-width: 516px;
    box-sizing: border-box;

    &:global(.sw-panel) {
      margin: 0;
      @media screen and (max-width: @bp-mobile-big) {
        padding: 32px 24px;
      }
      @media screen and (max-width: @bp-mobile-small) {
        max-width: 288px;
        margin: auto;
      }
    }
  }

  &__title {
    display: block;
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;
    margin: 0 0 24px;
  }

  &__text {
    box-sizing: border-box;
    flex-basis: 100%;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
}
</style>
